import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DropdownDataResponse } from '../../apiService/DropdownApiService';

interface DropdownState {
    data: { [speciesGroupId: string]: DropdownDataResponse };
    lastUpdated: { [speciesGroupId: string]: number };
    globalData: {
        count_methods: any[];
        ndff_gender: any[];
    };
}

const initialState: DropdownState = {
    data: {},
    lastUpdated: {},
    globalData: {
        count_methods: [],
        ndff_gender: []
    }
};

const dropdownSlice = createSlice({
    name: 'dropdown',
    initialState,
    reducers: {
        setDropdownData(state, action: PayloadAction<{ speciesGroupId: string; data: DropdownDataResponse }>) {
            const { speciesGroupId, data } = action.payload;
            state.data[speciesGroupId] = data;
            state.lastUpdated[speciesGroupId] = Date.now();
            
            // Update global data if available
            if (data.count_methods) {
                state.globalData.count_methods = data.count_methods;
            }
            if (data.ndff_gender) {
                state.globalData.ndff_gender = data.ndff_gender;
            }
        },
        clearDropdownData(state, action: PayloadAction<string>) {
            const speciesGroupId = action.payload;
            delete state.data[speciesGroupId];
            delete state.lastUpdated[speciesGroupId];
        },
        clearAllDropdownData(state) {
            state.data = {};
            state.lastUpdated = {};
            state.globalData = {
                count_methods: [],
                ndff_gender: []
            };
        },
    },
});

export const { setDropdownData, clearDropdownData, clearAllDropdownData } = dropdownSlice.actions;
export default dropdownSlice.reducer;